import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["disabled"]

import { ref } from "vue";

import { PRODUCT } from "@/constants/product.constants";
import { useProductsStore } from "@/stores/products.store";
import { useUIProductsStore } from "@/stores/ui-products.store";

import fileHelpers from "@/utils/file-helpers";

import ErrorMessage from "@/components/ErrorMessage.vue";
import Popup from "@/components/Popup.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProductImage',
  setup(__props) {

const uiProductsStore = useUIProductsStore();
const productsStore = useProductsStore();

const fileToUpload = ref<any | undefined>(undefined);
const fileTypeError = ref<string>("");
const productImageInput = ref<HTMLInputElement | undefined>(undefined);
const isClicked = ref<boolean>(false);

const fetchLocalFile = (): void => {
  if (productImageInput.value?.files) {
    const fileType = productImageInput.value.files[0].type;
    if (!fileType || !fileHelpers.isValidImageFileType(fileType)) {
      fileTypeError.value = PRODUCT.ERRORS.imageFileType;
      return;
    }
    fileTypeError.value = "";
    fileToUpload.value = productImageInput.value.files[0];
  }
};
const handleFileUpload = (): void => {
  isClicked.value = true;
  if (
    uiProductsStore.productToAddImage &&
    Number(uiProductsStore.productToAddImage) > 0
  ) {
    // if we change an image in an existing product
    const formData = new FormData();
    formData.append("image", fileToUpload.value);
    formData.append("product_id", `${uiProductsStore.productToAddImage}`);
    const payload = {
      formData: formData,
      product_id: uiProductsStore.productToAddImage
    };
    productsStore.addProductImage(payload).then(() => {
      uiProductsStore.closeProductImageModal();
    });
  } else {
    // if a product is new
    uiProductsStore.setNewProductImage(fileToUpload.value);
    uiProductsStore.closeProductImageModal();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    onClosePopup: _unref(uiProductsStore).closeProductImageModal
  }, {
    header: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("h3", null, "Upload a product image", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("form", {
        id: "product-image-form",
        onSubmit: _withModifiers(handleFileUpload, ["prevent"])
      }, [
        _createVNode(RightSidebarTitle, { title: 'Select an Image:' }),
        _createElementVNode("input", {
          type: "file",
          id: "product-image-upload-input",
          ref_key: "productImageInput",
          ref: productImageInput,
          onChange: fetchLocalFile
        }, null, 544),
        (fileTypeError.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              message: fileTypeError.value
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        form: "product-image-form",
        type: "submit",
        disabled: !fileToUpload.value || isClicked.value,
        class: "btn-1 full-width submit-btn"
      }, " Set as Product Image ", 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})